<template>
  <div class="text-center loadingview" flex="main:center cross:center" id="loadingview"
       style="width: 100%;height: 100%;position: absolute;left: 0;top:0">
    <div ref="main" class="main" v-if="showC">
      <div class="content">
        <div class="content-title" style="width: 90%;margin-left: 5%;">
          <p style="line-height: 40px;">您正在使用的浏览器可能不支持3D展示，为了达到更好的浏览体验，推荐使用以下浏览器</p>
          <p class="line"/>
        </div>
        <div class="content-box">
          <ul>
            <li @click="openUrl('https://www.google.cn/intl/zh-CN/chrome/')">
              <img :src="path+'static/images/pc/loading/loading_01.png'">
              <p>谷歌浏览器</p>
            </li>
            <li @click="openUrl('https://browser.360.cn')">
              <img :src="path+'static/images/pc/loading/loading_02.png'">
              <p>360安全浏览器</p>
            </li>
            <li @click="openUrl('https://ie.sogou.com')">
              <img :src="path+'static/images/pc/loading/loading_03.png'">
              <p>搜狗浏览器</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="main_close" @click="closeMain" @mouseenter="addHover" @mouseleave="removeHover">
        <img :src="path+'static/images/pc/loading/close1.png'">
      </div>
    </div>
    <v-loading ref="loading" style="position: absolute" v-if="showLoading"
               :style="{'top': showC || showA ? 'calc(50% + 4rem)' : 'calc(50% - 30px)','left':'calc(50% - 30px)'}"></v-loading>
  </div>
</template>

<script>
  import VLoading from "../../../compontents/loading";

  export default {
    name: "LoadingView",
    components: {VLoading},
    data() {
      return {
        showC:false,
        showA:false,
        showLoading:true,
        percent:0,
        carseries_id:getConfigure("carVersion").cbbCarSeriesId,
      }
    },
    props:{
      url:{
        default:'pc',
        type:String
      }
    },
    methods: {
      openUrl(url){
        var info = {
          dynamic: {
            carseries_id: this.carseries_id,
          }
        }
        if(url.indexOf("chrome")!=-1){
          track("dn_web-20210421172811-lm06-{carseries_id}",info);
        }
        else if(url.indexOf("360")){
          track("dn_web-20210421172811-lm04-{carseries_id}",info);
        }
        else{
          track("dn_web-20210421172811-cm01-{carseries_id}",info);
        }
        window.open(url);
      },
      closeMain(){
        var info = {
          dynamic: {
            carseries_id: this.carseries_id,
          }
        }
        track("dn_web-20210421172811-lm03-{carseries_id}",info);
        let me = this;
        if(this.showL){
          setTimeout(function () {
            this.showLoading = false;
            $('#loadingview').animate({'opacity': 0}, 1000, function () {
              $('#loadingview').remove();
            })
          }.bind(this), 200);
        }else{
          me.showC = false;
          let a =  -(4 * parseInt(document.documentElement.style.fontSize) + 36);
          $('#caseBlanche').css({'transform' : 'translateY('+ a + 'px)'});
          $('#caseBlanche').css({'-webkit-transform' : 'translateY('+ a + 'px)'});
        }
      },
      addHover(){

      },
      removeHover(){

      },
      setPercent(value){
        this.percent = (value/100);
        this.$refs.loading.setPercent(value+'%');
      },
      checkWebGL: function() {
        try {
          var canvas = document.createElement('canvas');
          return !!(window.WebGLRenderingContext &&
            (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
        } catch (e) {
          return false;
        }
      },
      checkWebGL2: function() {
        try {
          var canvas = document.createElement('canvas');
          return !!(window.WebGL2RenderingContext && canvas.getContext('webgl2'));

        } catch (e) {

          return false;

        }
      }
    },
    created(){
      var browser={
        versions:function(){
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            trident: u.indexOf('Trident') > -1, //IE内核
            presto: u.indexOf('Presto') > -1, //opera内核
            webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
            gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, //火狐内核
            mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
            webApp: u.indexOf('Safari') == -1 //是否web应该程序，没有头部与底部
          };
        }(),
        language:(navigator.browserLanguage || navigator.language).toLowerCase()
      };
      if(browser.versions.mobile){
        this.showA = false;
        this.showC = false;
      }
      else if(!this.checkWebGL()||!this.checkWebGL2()){
        this.showA = true;
        this.showC = true;
        this.$nextTick(function () {
          let a =  (- 3 * parseInt(document.documentElement.style.fontSize) + 20);
          $(this.$refs.main).animate({'opacity': 1,top: a  + 'px' },500);
          this.$emit('close');
        })
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss">
  .loadingview {
    overflow: hidden;
  }
  .loading_bac{
  }
  .loadingview:after {
    -webkit-filter: blur(20px);
    -moz-filter: blur(20px);
    -ms-filter: blur(20px);
    -o-filter: blur(20px);
    filter: blur(20px);
    margin: -30px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    content: '';
    bottom: 0;
  }

  .loadingview #caseBlanche {
    top: calc(50% + 4rem);
    transition: all 0.3s ease-in-out;
    transition-duration: 300ms;
  }
  .main{
    opacity: .1;
    position: absolute;
    top: -3rem;
    bottom: 0;
    left: 0;
    right: 0;
    width: 17.8rem;
    height: 8.28rem;
    max-width: 90%;
    line-height: 2;
    border:1px solid rgba(#ccc,0.5);
    margin: auto;
    border-radius:12px;
    background: rgba(255, 255, 255,.5);
    box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, .03);
    z-index: 1;
    overflow: hidden;
    .content{
      color:rgba(#000,0.5);
      margin-top: 1.48rem;
      .content-title{
        p:nth-child(1){
          font-weight: bold;
          font-size: 0.52rem;
          line-height: 0.52rem;
          color:rgba(#000,0.8);
          margin: 0;
        }
        p:nth-child(2){
          font-size: 0.36rem;
          margin-top: 0.38rem;
          margin-bottom: 0.68rem;
          color:rgba(#000,0.5);
        }
      }
      .line{
        width: 8.24rem;
        margin: auto;
        height: 1px;
        background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0) 10%,
            rgba(0, 0, 0, 0.05) 20%,
            rgba(0, 0, 0, 0.1) 30%,
            rgba(0, 0, 0, 0.15) 40%,
            rgba(0, 0, 0, 0.2) 50%,
            rgba(0, 0, 0, 0.15) 60%,
            rgba(0, 0, 0, 0.1) 70%,
            rgba(0, 0, 0, 0.05) 80%,
            rgba(0, 0, 0, 0) 90%,
            rgba(0, 0, 0, 0) 100%)
      }
      .content-box{
        margin-top: 0.8rem;
        ul{
          display: flex;
          align-items: center;
          justify-content: space-around;
          padding: 0 1.98rem;
          li{
            img{
              width: 2rem;
              height: 2rem;
            }
            p{
              margin-top: 0.2rem;
            }
          }
          li:hover{
            cursor: pointer;
            img{
              transform:translateY(-9px);
              transition: all 0.3s ease-in-out;
              -webkit-transform: translateY(-9px);
              transition-duration: 300ms;
            }
          }
        }
      }
    }
    .main_close{
      cursor: pointer;
      position: absolute;
      top:0.44rem;
      right: 0.6rem;
      img{
        width: 20px;
        height: 20px;
      }
    }
  }
</style>
